* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  --body-text-arrows-400: var(--main-titles-inputs-600);
  --card-border-color: var(--chart-103-pressed);
  --background-color: var(--chart-052-graph-background);
  --card-container-min-width: 400px;
}

.xdr-overview-content {
  height: 100%;
}

.wrapper {
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer) - 4px);
  background-color: var(--background-color);
  height: auto;
  min-height: 100%;
  .layout-3-columns {
    width: 100%;
  }
  .layout-3-columns > * {
    min-width: var(--card-container-min-width);
  }
}
.gz-card {
  display: flex;
  flex-flow: column;
  position: relative;
  border-radius: 4px;
  border: 1px solid var(--card-border-color);
  padding: calc(3 * var(--spacer));
  cursor: default;
  background-color: var(--white-layout-302-level-1-elevation);
}

gz-timeline-group {
  margin-top: calc(var(--spacer) * 3 - 2px);
}
